export default "__VITE_ASSET__CxUICilz__"